var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-end":""}},[_c('app-reference',{staticClass:"ma-0",attrs:{"label":"Направление","resource":"countries","component-name":"Country","outline":true,"height-field":44},on:{"input":_vm.changeDirection},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }